import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CreateListForm.style';
import FormInput from '../../ui/FormInput/FormInput';
import Button from '../../ui/Button/Button';

const CreateListForm = ({ onSubmit, validateList, error, loading, labels }) => {
  const [inputValue, setInputValue] = useState('');
  const handleChange = (event) => {
    setInputValue(event.target.value);
    validateList(event.target.value);
  };
  const handleSubmit = () => {
    onSubmit(inputValue, labels.defaultMyList);
  };
  return (
    <div className="form-container">
      <div className="form-title">{labels.formTitle}</div>
      <FormInput
        showLabel={false}
        type="text"
        onChange={handleChange}
        placeholder={labels.inputPlaceHolder}
        id="form-input-my-lists"
        errorText={error}
        className="placeholder"
      />
      <div className="form-button">
        <div className="box-button">
          <Button
            letterSpace="regular"
            type="mkp-secondary"
            onClick={handleSubmit}
            disabled={!!error || loading || !inputValue}
            id="myListCreateNewListButton"
            extraClasses="create-new-list-button"
          >
            {labels.save}
          </Button>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

CreateListForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  validateList: PropTypes.func.isRequired,
  labels: PropTypes.object,
};

CreateListForm.defaultProps = {
  error: '',
  loading: false,
  labels: {
    saveButton: 'Guardar',
    inputPlaceHolder: 'Ej. Compra del mes',
    formTitle: 'Ingresa un nombre para tu lista',
  },
};

export default CreateListForm;
